import _ from 'lodash'

export const getEstimateIdParam = (state, props) =>
  parseInt(_.get(props, 'match.params.estimateId'), 10)

export const getEstimatesList = (state, props) =>
  _.get(state, 'leadEstimateActions.leadEstimates.data')

export const getEstimateItems = (state, props) =>
  state.estimateItems || _.get(state, 'leadEstimateActions.leadEstimateItems.data')

export const getEstimateSections = (state, props) =>
  state.estimateSections || _.get(state, 'leadEstimateActions.leadEstimateSections.data')

export const getTemplateItems = (state, props) =>
  _.get(state, 'estimateTemplate.templateItems.data')

export const getTemplateSections = (state, props) =>
  _.get(state, 'estimateTemplate.templateSections.data')

export const getTemplates = (state, props) =>
  _.get(state, 'estimateTemplate.estimateTemplates.data')



// WEBPACK FOOTER //
// ./src/selectors/estimates.js